export default {
  emptyValue: "-",
  new: "new"
};
